export default __webpack_public_path__ + "static/media/quelltheether.bdb22ef2.png";